import api from "./api";

/** Get (and lazily create) a stable random visitor id in localStorage. */
function getVisitorId() {
  try {
    let v = localStorage.getItem("vico_vid");
    if (!v) {
      const buf = new Uint8Array(16);
      (window.crypto || window.msCrypto).getRandomValues(buf);
      v = Array.from(buf).map(b => b.toString(16).padStart(2, "0")).join("");
      localStorage.setItem("vico_vid", v);
    }
    return v;
  } catch {
    return "";
  }
}

/** Record a page view once per session per path. */
export function trackPageView() {
  try {
    const path = window.location.pathname + window.location.search;
    const key = `vico_seen_${path}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    api.post("/analytics/hit", {
      event: "page_view",
      path,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    }).catch((err) => {
      // Non-critical: analytics endpoint unreachable or ad-blocker. Log for debugging only.
      if (process.env.NODE_ENV !== "production") console.warn("analytics page_view failed:", err?.message);
    });
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("analytics trackPageView error:", e?.message);
  }
}

/** Record a click on a CTA (e.g. Book now). Idempotent per session+event. */
export function trackClick(event = "click_book") {
  try {
    const key = `vico_click_${event}`;
    if (sessionStorage.getItem(key)) return;
    sessionStorage.setItem(key, "1");
    api.post("/analytics/hit", {
      event,
      path: window.location.pathname,
      referrer: document.referrer || "",
      visitor_id: getVisitorId(),
    }).catch((err) => {
      if (process.env.NODE_ENV !== "production") console.warn("analytics click failed:", err?.message);
    });
  } catch (e) {
    if (process.env.NODE_ENV !== "production") console.warn("analytics trackClick error:", e?.message);
  }
}
